import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const CreateCompanyMappingPage = withSuspense(lazy(() => import('./create-company-mapping')));
export default CreateCompanyMappingPage;
